<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Izaberite PDV period"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl!"
  [ctrlDisabled]="shouldDisable"
></kodit-dropdown>
